import AnimationWrapper from "./AnimationWrapper";

export default AnimationWrapper;
